var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryAthlete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/choose category Copy 4@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-V3-Account---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Influencer-view_Instagram-Copy-2-(2)",
    transform: "translate(-650.000000, -770.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(585.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.000000, 87.000000)",
    id: "basketball"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,16 C3.58886957,16 0,12.4114783 0,8 C0,3.58852174 3.58886957,0 8,0 C12.4111304,0 16,3.58852174 16,8 C16,12.4114783 12.4111304,16 8,16 Z",
    id: "Path",
    fill: "#EA9860"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#444444",
    x: 7.65217391,
    y: 0,
    width: 1,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#444444",
    x: 0,
    y: 7.65217391,
    width: 16,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86956522,8 C4.86956522,5.75026087 3.9346087,3.71582609 2.43478261,2.26086957 C2.26782609,2.42295652 2.10817391,2.592 1.95582609,2.768 C3.3213913,4.096 4.17391304,5.94921739 4.17391304,8 C4.17391304,10.0507826 3.3213913,11.904 1.95582609,13.232 C2.10817391,13.408 2.26782609,13.5770435 2.43478261,13.7391304 C3.9346087,12.2841739 4.86956522,10.2497391 4.86956522,8 Z",
    id: "Path",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0441739,13.232 C12.6786087,11.904 11.826087,10.0507826 11.826087,8 C11.826087,5.94921739 12.6786087,4.096 14.0441739,2.768 C13.8918261,2.592 13.7321739,2.42295652 13.5652174,2.26086957 C12.0653913,3.71582609 11.1304348,5.75026087 11.1304348,8 C11.1304348,10.2497391 12.0653913,12.2841739 13.5652174,13.7391304 C13.7321739,13.5770435 13.8918261,13.408 14.0441739,13.232 Z",
    id: "Path",
    fill: "#444444"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryAthlete);
export default __webpack_public_path__ + "static/media/category_athlete.f1985a68347bfa4b937ba4c5d0107471.svg";
export { ForwardRef as ReactComponent };